import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-saver-delivery-method-info',
  templateUrl: './saver-delivery-method-info.component.html',
  styleUrls: ['./saver-delivery-method-info.component.scss']
})
export class SaverDeliveryMethodInfoComponent implements OnInit {

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public _data: any,
    public _bottomSheetRef: MatBottomSheetRef<SaverDeliveryMethodInfoComponent>
  ) {
    
  }

  ngOnInit(): void {
  }

}
